/* app/js/src/components/media-transcoder/jobs/job-settings/job-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.header {
  border-bottom: 3px solid #dde3e7;
  padding: 0 15px 0 30px;
  background-color: #f1f3f4;
}
.footer {
  border-top: 1px solid #dde3e7;
  padding: 15px 30px;
}
.red {
  background-color: red;
}
.blue {
  background-color: blue;
}
.job-settings-container {
  box-shadow: 3px 2px 26px 2px rgba(0, 0, 0, 0.5019607843);
  border-radius: 2px;
}
.job-settings-container .field {
  margin-top: 0.5vw;
  margin-bottom: 0.5vw;
}
.job-settings-container .field evrideo-simple-text-input {
  width: 100%;
}
.job-settings-container .field .title {
  width: 13vw;
}
.job-settings-container evrideo-media-files-landzone {
  width: 100%;
  height: 10vw;
  display: block;
  overflow: auto;
  border: 1px solid #f1f3f4;
  overflow-x: hidden;
}
.job-settings-container video-container {
  position: relative;
  width: 100%;
  height: 300px;
}
.margin-left-2vw {
  margin-left: 2vw;
}
.margin-left-1vw {
  margin-left: 1vw;
}
.margin-right-1vw {
  margin-right: 1vw;
}
.margin-bottom-2vw {
  margin-bottom: 2vw;
}
.margin-bottom-1vw {
  margin-bottom: 1vw;
}
.btn-text {
  color: white;
}
.lading-zone-description {
  text-align: center;
  transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.2s;
  margin-top: 5px;
  padding: 7px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  border: 1px solid #e1e6eb;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background: #ffffff;
}
.mandatory {
  color: red;
  display: inline-block;
  vertical-align: middle;
  padding-top: 0.2vw;
}
.mandatory:before {
  content: "*";
}
.abort-btn {
  margin-right: 1vw;
}
.trim-fields {
  width: 20vw;
  justify-content: space-between;
}
evrideo-time-editor {
  width: 8vw;
}
.profile-type-selector {
  padding: 10px 15px;
  border-bottom: 1px solid #e1e6eb;
}
.profile-type-selector .radio-button-group {
  display: flex;
  gap: 10px;
}
.profile-type-selector .radio-button-group .radio-button {
  flex: 1;
  padding: 8px 16px;
  border: 1px solid #dde3e7;
  background-color: #ffffff;
  color: #333333;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.profile-type-selector .radio-button-group .radio-button:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}
.profile-type-selector .radio-button-group .radio-button.active {
  background-color: #232f3a;
  border-color: #232f3a;
  color: #ffffff;
}
.profile-type-selector .radio-button-group .radio-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.tab-navigation {
  margin-bottom: 1vw;
  border-bottom: 1px solid #e1e6eb;
}
.tab-navigation .tab-button {
  padding: 10px 20px;
  border: 1px solid #e1e6eb;
  background-color: #ffffff;
  color: #333333;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-right: 5px;
  border-bottom: none;
}
.tab-navigation .tab-button:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}
.tab-navigation .tab-button.active {
  background-color: #232f3a;
  border-color: #232f3a;
  color: #ffffff;
  border-bottom: 1px solid #232f3a;
  margin-bottom: -1px;
}
.tab-navigation .tab-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.tab-content .tab-panel {
  padding: 1vw 0;
}
/*# sourceMappingURL=job-settings.component.css.map */
